import { render, staticRenderFns } from "./shopifyWelcome.vue?vue&type=template&id=5192784e&"
import script from "./shopifyWelcome.vue?vue&type=script&lang=js&"
export * from "./shopifyWelcome.vue?vue&type=script&lang=js&"
import style0 from "./shopifyWelcome.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports